import { type ServiceIdentifier, inject, injectable } from 'inversify'

import { HTTPClient } from './Clients/HTTPClient'
import type { ApiGateWay } from './GateWays/ApiGateWay'

import { AltApplication } from '../../package/AltApplication'
import { AltContainer } from '../../package/DI/Container'

@injectable()
export default class ApiService {
  readonly ioc: AltContainer

  constructor(
    @inject(AltApplication) readonly app: AltApplication,
    @inject(HTTPClient) readonly client: HTTPClient,
  ) {
    this.ioc = new AltContainer({ parent: app.container })
    this.client = client as HTTPClient
  }

  register<T extends ApiGateWay>(
    GateWay: { new (...args: any[]): T },
    alias?: ServiceIdentifier<T>,
  ) {
    this.ioc
      .bind<T>(alias || GateWay)
      .to(GateWay)
      .inSingletonScope()
  }

  resolve<T>(identifier: ServiceIdentifier<T>) {
    return this.ioc.get<T>(identifier)
  }
}
